import React from 'react';
import { AccordionList } from '@ygtechnologies/rubus-ui';
import { ProductCardList } from '@/seller/components/products/ProductCard/ProductCardList';
import { BuyerOptionCard } from '../../BuyerOptionCard';
import theme from '../Room.module.scss';
import { ConfiguratorGroupDto } from '@/services/configurator';
import { BuyerOptionAccordion } from '../../BuyerOptionAccordion';
import { getVisibleBuyerOptions } from '../../utils/visibleBuyerOptions';
import { useOptionConfigurator } from '../../OptionConfiguratorContext';

interface RoomOptionAccordionListProps {
    groups: ConfiguratorGroupDto[];
    is3d?: boolean;
    /** Fired when a group is expanded — used to pre-load that group's configurator visuals. */
    onGroupExpand?: (group: ConfiguratorGroupDto) => void;
}

export const RoomOptionAccordionList: React.FC<RoomOptionAccordionListProps> = ({
    groups,
    is3d = false,
    onGroupExpand,
}) => {
    const { isShowroom } = useOptionConfigurator();
    return (
        <AccordionList className={theme.accordionList} scrollIntoView allowMultiple={false}>
            {groups.map((group) => (
                <BuyerOptionAccordion key={group.id} group={group} onExpand={onGroupExpand}>
                    <ProductCardList>
                        {getVisibleBuyerOptions(group, isShowroom).map((option) => (
                            <BuyerOptionCard
                                key={option.id}
                                option={option}
                                isSelected={!!option.selected}
                                groupName={group.name}
                                is3d={is3d}
                            />
                        ))}
                    </ProductCardList>
                </BuyerOptionAccordion>
            ))}
        </AccordionList>
    );
};
